export default {
  renderStatus: (status) => {
    return {
      text: status === 'ACTIVE' ? 'Đang sử dụng' : 'Ngừng sử dụng',
      color: status === 'ACTIVE' ? 'success' : 'danger',
    }
  },
}
